import { Box, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import PaperComponent from "../../unit/PaperComponent";
import CustomNumberTextField from "../../unit/forms/CustomNumberTextField";
import useNotify from "../../unit/useNotify";
export default function CustomLoanUpdateChargedOffDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record: recordProp } = props;
  const [open, setOpen] = React.useState(false);
  const [chargeOffAmount, setChargeOffAmount] = React.useState(
    recordProp?.loan?.activePrincipalBalance
  );
  const [chargeOffAmountError, setChargeOffAmountError] = React.useState(false);
  const [chagedOffAmountShow, setChagedOffAmountShow] = React.useState(false);
  const [recoveryAmount, setRecoveryAmount] = React.useState(0);
  const [recoveryAmountError, setRecoveryAmountError] = React.useState(false);
  const [netChargeOffAmount, setNetChargeOffAmount] = React.useState(
    recordProp?.loan?.activePrincipalBalance
  );
  const refresh = useRefresh();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  React.useEffect(() => {
    console.log("chargeOffAmount =====>", chargeOffAmount, recoveryAmount);
    const netAmount = chargeOffAmount - recoveryAmount;
    setNetChargeOffAmount(netAmount);
  }, [chargeOffAmount, recoveryAmount]);
  return (
    <div>
      <Button
        label="Update Amount"
        variant="contained"
        size="medium"
        color="primary"
        sx={{ marginLeft: "10px", width: "175px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="loan-update-charged-off-status-dialog"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.loannum = recordProp?.loan?.loanNum;
            console.log("update loan status formJson =====>", formJson);
            //charged amount, recovery amount, net charge off amount, recovery date can't not be negative, must have value
            if (
              chargeOffAmount < 0 ||
              recoveryAmount < 0 ||
              netChargeOffAmount < 0 ||
              formJson.recoverydate === ""
            ) {
              errorNotify("Please check all the inputs");
              return;
            }
            formJson.netchargeoffamount = netChargeOffAmount;
            const reqUrl = `loans/actions/updateChargedOffAmount`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            // console.log(responseBack.data);
            if (responseBack && responseBack.code == "200") {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle
            title={`Charge-Off Loan`}
            subTitle="Update Amount"
          />
        </DialogTitle>
        <DialogContent>
          <Box sx={{ height: "500px", minHeight: "300px" }}>
            <DialogContentText>
              {" "}
              <Typography variant="body1" sx={{ color: "red" }}>
                This operation cannot be reversed. Please check all the inputs
                before clicking "Confirm" to proceed.
              </Typography>
            </DialogContentText>
            <Grid container sx={{ mt: 2, mb: 2, pb: 2 }}>
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Charge-Off Amount" />
                </Grid>
                <Grid item xs={5}>
                  <CustomNumberTextField
                    fullWidth
                    id="chargeoffamount"
                    name="chargeoffamount"
                    variant="outlined"
                    defaultValue={chargeOffAmount}
                    onChange={(e) => {
                      setChargeOffAmount(e.target.value);
                      if (e.target.value < 0) {
                        setChargeOffAmountError(true);
                      } else {
                        setChargeOffAmountError(false);
                      }
                    }}
                    required={chagedOffAmountShow}
                    error={chargeOffAmountError}
                    helperText={
                      chargeOffAmountError ? "value must be greater than 0" : ""
                    }
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
              {/* Recovery Amount */}
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Recovery Amount" />
                </Grid>
                <Grid item xs={5}>
                  <CustomNumberTextField
                    fullWidth
                    id="recoveryamount"
                    name="recoveryamount"
                    variant="outlined"
                    defaultValue={recoveryAmount}
                    onChange={(e) => {
                      setRecoveryAmount(e.target.value);
                      if (e.target.value < 0) {
                        setRecoveryAmountError(true);
                      } else {
                        setRecoveryAmountError(false);
                      }
                    }}
                    required={true}
                    error={recoveryAmountError}
                    helperText={
                      recoveryAmountError ? "value must be greater than 0" : ""
                    }
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>

              {/* Net Charge-Off Amount */}
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Net Charge-Off Amount" />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    id="netchargeoffamount"
                    name="netchargeoffamount"
                    variant="outlined"
                    defaultValue={netChargeOffAmount}
                    value={netChargeOffAmount}
                    sx={{
                      "& .MuiInputBase-input": {
                        backgroundColor: "#eee",
                      },
                    }}
                    disabled={true}
                    error={netChargeOffAmount < 0}
                    helperText={
                      netChargeOffAmount < 0
                        ? "value must be greater than 0"
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
              {/* Recovery Date */}
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Recovery Date" />
                </Grid>
                <Grid item xs={5}>
                  <CustomDateTextInput
                    fullWidth
                    id="recoverydate"
                    name="recoverydate"
                    variant="outlined"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    required={true}
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Confirm" />
        </DialogActions>
      </Dialog>
    </div>
  );
}
